import scrollLock from 'scroll-lock';
import View from '../view/view';
import mitt from 'mitt';

class Controller {
	constructor() {
		this.events = mitt();

		this.touch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		this.passiveEventsSupported = (() => {
			// passive event listeners support test from MDN
			let result = false;
			try {
				window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
					get: () => result = true
				}));
			} catch (err) {}
			return result;
		})();

		View.initAllGlobal();
		View.initAllLocal(document.body);
	}
}

export default new Controller();